import EBarSnippetBlock from './EBarSnippetBlock';

export default EBarSnippetBlock;
